import { SwitchEvent } from '@nextui-org/react';
import React from 'react';

import HelpTooltip from '../HelpTooltip';
import { Container, StyledSwitch, Title } from './Switch.styles';

interface SwitchProps {
  checked: boolean;
  onChange?: (e: SwitchEvent) => void;
  title?: string;
  disabled?: boolean;
  helpText?: string;
}

const Switch = ({ title, helpText, ...props }: SwitchProps) => {
  return (
    <Container>
      <StyledSwitch size="xs" animated={false} {...props} />
      {title && <Title>{title}</Title>}
      {helpText && <HelpTooltip $helpText={helpText} />}
    </Container>
  );
};

export default Switch;
